<template>
  <WaiverLayout />
</template>

<script setup>
import WaiverLayout from './components/WaiverLayout.vue';
</script>
